import React, {ChangeEvent, useEffect, useState} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import ReactSelect from 'react-select';
import ReactSelectAsync from 'react-select/async-creatable';

import {LoadingIndicator} from '../components/LoadingIndicator';
import {ActivityButton} from '../components/ActivityButton';
import {ButtonDropdown} from '../components/ButtonDropdown';
import {NavUserMaintenance} from '../components/NavUserMaintenance';
import {Flow, FlowFetchResponse} from '../_services/Flow';
import {User} from '../_services/User';
import {Form as FormType, StepAssignee} from '../types';
import {Modal} from '../components/Modal';

type DropdownMaintenancePageProps = {};

type EditModalState = {
    shouldShow: boolean;
    isSaving: boolean;
    record: any;
    recordIndex: number;
    table: any;
}

type ImportExcelModalState = {
    shouldShow: boolean;
    table: any;
}

const initialEditModalState: EditModalState = {
    shouldShow: false,
    isSaving: false,
    record: {},
    recordIndex: -1,
    table: {}
};

const initialImportExcelModalState: ImportExcelModalState = {
    shouldShow: false,
    table: {}
};

export const TableMaintenance: React.FunctionComponent<DropdownMaintenancePageProps> = ({}) => {
    const {workflowId} = useParams();
    const history = useHistory();

    const [pageIsLoading, setPageIsLoading]: any = useState(true);
    const [errorMessage, setErrorMessage]: any = useState('');

    const [form, setForm] = useState<FormType>();
    const [tables, setTables] = useState<any>([]);
    const [selectedTable, setSelectedTable] = useState<any>();
    const [isEditing, setIsEditing] = useState<any>({});
    const [editModalState, setEditModalState] = useState<any>({...initialEditModalState})
    const [importExcelModalState, setImportExcelModalState] = useState<any>({...initialImportExcelModalState})
    const [isDeletingMap, setIsDeletingMap] = useState<any>({});
    const [inputState, setInputState] = useState<string>('');

    useEffect(() => {
        Flow.getInstance().getForm(workflowId)
            .then((response: FlowFetchResponse) => {
                if (response.ok) {
                    setForm(response.json.form);
                } else {
                    throw Error(response?.json?.message || 'Error fetching Workflow');
                }
            })
            .catch((error: any) => {
                setErrorMessage(error?.message || error || 'Error fetching Workflow');
            })
            .finally(() => {
            });
    }, [workflowId]);

    useEffect(() => {
        if (form?.id) {
            {/* remove to run locally*/
            }
            if (!(User.getInstance().isIsWfo() || (form?.flow_form_admin_role && User.getInstance().hasRole(form.flow_form_admin_role)))) {
                history.replace('/');
            }
            {/* remove to run locally*/
            }
            Flow.getInstance().getTables(form.id)
                .then((response: FlowFetchResponse) => {
                    if (response.ok) {
                        setTables(response?.json && Array.isArray(response.json) ? response.json : []);
                    } else {
                        throw new Error(response?.json?.message);
                    }
                })
                .catch(error => {
                    setErrorMessage(error?.message || 'Error fetching tables');
                })
                .finally(() => {
                    setPageIsLoading(false);
                })
        }
    }, [form]);

    const getTabledata = (table) => {
        Flow.getInstance().getTabledata(table.id)
            .then((response: FlowFetchResponse) => {
                if (response.ok) {
                    setSelectedTable((state: any) => ({
                        ...state,
                        data: response.json
                    }))
                } else {
                    throw new Error(response?.json?.message || '');
                }
            })
            .catch(error => {

            })
            .finally(() => {

            })
    }

//  exportTable - invoke api to export to a file
    const exportTable = (table) => {

        fetch(`/p/flow/api/tables/${table.id}/export`)
            .then(resp => resp.status === 200 ? resp.blob() : Promise.reject('export failed'))
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = `${table.name}.export`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch(() => alert('export failed'));
    }

    const handleDelete = (record: any, index: number) => {
        setIsDeletingMap(state => ({
            ...state,
            [record[selectedTable.primaryKey]]: true
        }));

        Flow.getInstance().deleteTabledata(selectedTable.id, record[selectedTable.primaryKey])
            .then((response: FlowFetchResponse) => {
                if (response.ok) {
                    setSelectedTable((state) => ({
                        ...state,
                        data: {
                            ...state.data,
                            data: [
                                ...state.data.data.slice(0, index),
                                ...state.data.data.slice(index + 1)
                            ]
                        }
                    }));
                } else {
                    throw Error(response?.json?.message);
                }
            })
            .catch(error => {
                alert(error?.message || error || 'Error deleting record');
            })
            .finally(() => {
                setIsDeletingMap(state => ({
                    ...state,
                    [record[selectedTable.primaryKey]]: false
                }));
            })
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    {form && <h1 className={'abb-header'}>{form.title}</h1>}
                    <h2>Table Maintenance</h2>
                </div>
                <div className="col-12">
                    {workflowId && <NavUserMaintenance workflowId={workflowId}/>}
                </div>
                <div className="col-12 p-4">
                    {errorMessage && <p className="alert alert-danger">{errorMessage}</p>}
                    {pageIsLoading && <LoadingIndicator/>}

                    <div className="row justify-content-between">
                        <div className="col-6">
                            <ReactSelect
                                placeholder="Select a Table..."
                                required={true}
                                isClearable={true}
                                value={selectedTable}
                                options={tables?.map(t => ({
                                    ...t,
                                    label: t.name,
                                    value: t.id,
                                }))}
                                onChange={(option) => {
                                    setSelectedTable(option);
                                    if (option && option?.id) {
                                        getTabledata(option);
                                    }
                                }}
                            />
                        </div>

                        <div className="">
                            {selectedTable &&
                                <ButtonDropdown
                                    label={`Add ${selectedTable.name} Record`}
                                    buttonClassName="btn btn-primary dropdown-toggle"
                                    containerClass="w-100"
                                    menuClassName="m-1"
                                    isActive={false}
                                    options={[
                                        {value: 'add', label: 'Add', text: 'Add'},
                                        /* {value: 'import', label: 'Import', text: 'Import'}, */
                                    ]}

                                    onSelect={(value: string, choice: any) => {
                                        if (value === 'add') {
                                            setEditModalState(state => ({
                                                ...state,
                                                shouldShow: true,
                                                record: {},
                                                recordIndex: -1,
                                                table: selectedTable
                                            }));
                                        }

                                        if (value === 'import') {
                                            setImportExcelModalState(state => ({
                                                ...state,
                                                shouldShow: true,
                                                table: selectedTable
                                            }));
                                        }

                                        console.log('selectedValue ' + value);
                                        console.log('choice ', choice);
                                    }}
                                />
                            }
                        </div>
                    </div>
                    {selectedTable?.description &&
                        <div className="row">
                            <div className={'col'}>
                                <div dangerouslySetInnerHTML={{__html: selectedTable.description}} />
                            </div>
                        </div>
                    }

                    {selectedTable &&
                        <div className="row">
                            <div className="col col-md-6 offset-md-3 mt-3 mb-2">
                                <input type="text"
                                       className="form-control form-control-lg"
                                       placeholder="search"
                                       value={inputState}

                                       onChange={(e) => {
                                           setInputState(e.target.value);
                                       }}

                                />
                            </div>
                        </div>
                    }

                    {selectedTable && // table
                        <div className="row">
                            <div className="col-12 mt-2">
                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead>
                                        <tr>
                                            <th/>
                                            {selectedTable.columns.map(c => (
                                                <th key={c.name}>{c.displayName}</th>
                                            ))}
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            selectedTable?.data?.data?.filter((r: any) => selectedTable.columns.some((c: any) =>
                                                r[c.name]?.includes(inputState))).map((r: any, index: number) => (
                                                <tr key={`row_${r[selectedTable.primaryKey]}`}>
                                                    <td style={{whiteSpace: 'nowrap'}}>
                                                        <button type="button"
                                                                className="btn btn-sm btn-link"
                                                                disabled={isDeletingMap.hasOwnProperty(r[selectedTable.primaryKey]) && isDeletingMap[r[selectedTable.primaryKey]]}
                                                                onClick={() => {
                                                                    setEditModalState(state => ({
                                                                        ...state,
                                                                        shouldShow: true,
                                                                        record: r,
                                                                        recordIndex: index,
                                                                        table: selectedTable
                                                                    }));
                                                                }}
                                                        >Edit
                                                        </button>
                                                        <button type="button"
                                                                className="btn btn-sm btn-link"
                                                                disabled={isDeletingMap.hasOwnProperty(r[selectedTable.primaryKey]) && isDeletingMap[r[selectedTable.primaryKey]]}
                                                                onClick={() => handleDelete(r, index)}
                                                        >Delete
                                                        </button>
                                                        {isDeletingMap.hasOwnProperty(r[selectedTable.primaryKey]) && isDeletingMap[r[selectedTable.primaryKey]] &&
                                                            <i className="fas fa-spinner fa-spin"></i>
                                                        }
                                                    </td>
                                                    {selectedTable.columns.map(c => (
                                                        <td key={`${r[selectedTable.primaryKey]}_${c.name}`}
                                                            onDoubleClick={(e) => {
                                                                /*
                                                                const primaryKey = r[selectedTable.primaryKey];

                                                                // can't edit row primary key
                                                                if (c.primaryKey) {
                                                                    return false;
                                                                }

                                                                setIsEditing(state => ({
                                                                    ...state,
                                                                    [primaryKey]: {
                                                                        ...state[primaryKey],
                                                                        [c.name]: true
                                                                    }
                                                                }))
                                                                 */
                                                            }}
                                                        >
                                                            {
                                                                isEditing.hasOwnProperty(r[selectedTable.primaryKey]) &&
                                                                isEditing[r[selectedTable.primaryKey]].hasOwnProperty(c.name) &&
                                                                isEditing[r[selectedTable.primaryKey]][c.name] ?
                                                                    <input type="text"
                                                                           className="form-control"
                                                                           value={r[c.name]}
                                                                           onChange={(e) => {
                                                                           }}
                                                                    />
                                                                    :
                                                                    r[c.name]
                                                            }
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                {/*
                                <button type="button"
                                        className="btn btn-primary mt-2"
                                        onClick={() => {
                                            exportTable(selectedTable)
                                        }}
                                >Export
                                </button>
                                */}
                            </div>
                        </div>
                    }

                </div>
            </div>
            {editModalState?.shouldShow &&
                <EditRecordModal
                    record={editModalState.record}
                    table={editModalState.table}
                    close={() => setEditModalState({...initialEditModalState})}
                    onSave={(record: any) => {
                        setSelectedTable((state) => ({
                            ...state,
                            data: {
                                ...state.data,
                                data: [
                                    ...state.data.data.slice(0, editModalState.recordIndex),
                                    record,
                                    ...(editModalState.recordIndex >= 0 ? state.data.data.slice(editModalState.recordIndex + 1) : [])
                                ]
                            }
                        }))
                    }}
                />
            }
            {importExcelModalState?.shouldShow &&
                <ImportExcelModal
                    table={importExcelModalState.table}
                    close={() => setImportExcelModalState({...initialImportExcelModalState})}
                />

            }
        </>
    );
};

type EditRecordModalProps = {
    record: any;
    table: any;
    close: () => void;
    onSave: (record: any) => void;
};

const EditRecordModal: React.FunctionComponent<EditRecordModalProps> = ({
                                                                            record,
                                                                            table,
                                                                            close,
                                                                            onSave
                                                                        }) => {
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [formState, setFormState] = useState<any>({...record});

    const getComponentForColumn = (column) => {
        switch (column.inputType) {
            case 'select':
                if (column?.inputTypeOptions?.autocomplete) {
                    return (
                        <ReactSelectAsync
                            placeholder="Begin Typing"
                            isDisabled={isSaving}
                            isClearable={true}
                            createOptionPosition={'first'}
                            getNewOptionData={(userInput: string) => ({
                                label: userInput,
                                value: userInput
                            })}
                            value={formState[column.name] ? {label: formState[column.name], value: formState[column.name]} : null}
                            onChange={handleSelectChange(column)}
                            loadOptions={() => {
                                return Flow.getInstance().getTabledataDistinctValuesForColumn(table.id, column)
                                    .then((response: FlowFetchResponse) => {
                                        return response.json.map((v: any) => ({
                                            value: v,
                                            label: v
                                        }));
                                    });
                            }}
                        />
                    );
                } else {
                    return (
                        <ReactSelect
                            isDisabled={isSaving}
                            isClearable={true}
                            value={formState[column.name] ? {label: formState[column.name], value: formState[column.name]} : null}
                            onChange={handleSelectChange(column)}
                            options={column?.inputTypeOptions?.choices}
                        />
                    );
                }
            case 'textarea':
                return (
                    <textarea rows={5}
                              disabled={isSaving}
                              className="form-control"
                              value={formState[column.name] || ''}
                              onChange={handleInputChange(column)}
                    />
                )
            default:
                return (
                    <input type={'text'}
                           disabled={isSaving}
                           className="form-control"
                           value={formState[column.name] || ''}
                           onChange={handleInputChange(column)}
                    />
                )
        }
    }

    const handleSave = () => {
        setIsSaving(true);
        Flow.getInstance().saveTabledata(table.id, record[table.primaryKey] || 0, formState)
            .then((response: FlowFetchResponse) => {
                if (response.ok) {
                    onSave(response.json);
                    close();
                } else {
                    throw Error(response?.json?.message);
                }
            })
            .catch(error => {
                alert(error || 'Error saving record');
            })
            .finally(() => {
                setIsSaving(false);
            })
    }

    const handleInputChange = (column: any) => (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = e.target.value;
        setFormState((state: any) => ({
            ...state,
            [column.name]: value
        }));
    }

    const handleSelectChange = (column: any) => (option: any) => {
        setFormState((state: any) => ({
            ...state,
            [column.name]: option?.value || ''
        }))
    }

    return (
        <Modal size={'lg'}>
            <div className="modal-header">
                <h5 className="modal-title">{
                    record.hasOwnProperty(table.primaryKey) && record[table.primaryKey] ?
                        <>Edit {table.name} Record#{record[table.primaryKey]}</>
                        :
                        <>New {table.name} Record</>
                }</h5>
                <button type="button"
                        className="close"
                        aria-label="Close"
                        tabIndex={-1}
                        onClick={close}
                >
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div className="modal-body">
                {table.columns.filter(c => !c?.primaryKey).map(c => (
                    <div className="form-group">
                        <label>{c.displayName}</label>
                        {c?.description && <small className="d-block">{c.description}</small>}
                        {getComponentForColumn(c)}
                    </div>
                ))}
            </div>
            <div className="modal-footer">
                <button type="button"
                        className="btn btn-secondary"
                        onClick={close}
                        disabled={isSaving}
                >Cancel
                </button>
                <ActivityButton
                    className="btn btn-primary"
                    isActive={isSaving}
                    onClick={handleSave}
                >Save</ActivityButton>
            </div>
        </Modal>
    )
}

type ImportExcelModalProps = {
    table: any;
    close: () => void;
};

const ImportExcelModal: React.FunctionComponent<ImportExcelModalProps> = ({table, close}) => {

    const [excelUploadFile, setExcelUploadFile] = useState();
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [isWorking, setIsWorking] = useState<boolean>(false);

    const handleUpload = () => {

        if (!excelUploadFile) {
            setErrorMessage('You must select a file');
            return;
        }

        setIsWorking(true);
        setErrorMessage('');

        Flow.getInstance().tableUpload(table.id, excelUploadFile)
            .then((response: FlowFetchResponse) => {
                if (response.ok) {
                    close();
                } else {
                    setErrorMessage(response?.json?.message || 'Error uploading file');
                }
                setIsWorking(false);
            })
            .catch((error: any) => {
                setIsWorking(false);
                setErrorMessage(error || 'Error uploading file');
            });
    };

    return (
        <Modal size={'lg'}>
            <div className="modal-header">
                <h5 className="modal-title">Import</h5>
            </div>

            <div className="modal-body">

                <div className="form-check">
                    <input type="checkbox"
                           className="form-check-input"
                           id="delete-all-records"
                    />
                    <label className="form-check-label" htmlFor="delete-all-records">
                        Delete all records before import
                    </label>
                </div>


                {errorMessage && <p className="alert alert-danger">{errorMessage}</p>}

                <p>Download the Excel template <a href={`/p/flow/api/tables/${table.id}/import-template`}>here</a> Fill out and upload in the field below. </p>
                <p>Click the Upload button to upload the File.</p>

                <p><strong>Do not</strong> change the order of any of the fields.</p>
                <p><strong>Do not</strong> remove the header row</p>

                <div className="form-group">
                    <input type="file"
                           className="form-control-file"
                           onChange={(e: ChangeEvent<HTMLInputElement>) => {
                               e.target &&
                               e.target.files &&
                               e.target.files.length &&
                               setExcelUploadFile(e.target.files[0])
                           }}
                    />
                </div>
            </div>
            <div className="modal-footer">
                <button type="button"
                        className="close"
                        aria-label="Close"
                        tabIndex={-1}
                        onClick={close}

                >Cancel
                </button>

                <ActivityButton
                    isActive={isWorking}
                    className="btn btn-primary"
                    onClick={() => {
                        handleUpload();
                    }}
                >
                    Upload
                </ActivityButton>
            </div>

        </Modal>
    )
} 
    